'use client';
import { useEffect, useState } from 'react';
import { useAppStore } from '@/store/app';
import { ensureBrowserPush } from '@/lib/push';

const NOTIFY_GUIDE_KEY = 'ailumix_notify_guide_v1';

const COPY: Record<string, { title: string; desc: string; btn: string; skip: string; done: string; err: string }> = {
  en: { title: 'Stay ahead of the market', desc: 'Enable browser push to get instant alerts when your price alerts or signals trigger.', btn: 'Enable push', skip: 'Not now', done: 'Push enabled', err: 'Push was blocked. You can enable it later in your browser settings.' },
  'zh-Hans': { title: '开启实时提醒', desc: '开启浏览器推送，预警触发时第一时间通知你，不错过任何机会。', btn: '开启推送', skip: '暂不', done: '已开启推送', err: '推送被拒绝，可稍后在浏览器设置中开启。' },
  'zh-Hant': { title: '開啟即時提醒', desc: '開啟瀏覽器推送，預警觸發時第一時間通知你，不錯過任何機會。', btn: '開啟推送', skip: '暫不', done: '已開啟推送', err: '推送被拒絕，可稍後在瀏覽器設定中開啟。' },
};

export default function NotificationGuide() {
  const user = useAppStore((s) => s.user);
  const language = useAppStore((s) => s.language) as string;
  const [open, setOpen] = useState(false);
  const [state, setState] = useState<'idle' | 'done' | 'err'>('idle');

  useEffect(() => {
    if (!user) return;
    if (typeof window === 'undefined') return;
    if (localStorage.getItem(NOTIFY_GUIDE_KEY) === '1') return;
    if (!('Notification' in window)) { localStorage.setItem(NOTIFY_GUIDE_KEY, '1'); return; }
    if (Notification.permission === 'granted') { localStorage.setItem(NOTIFY_GUIDE_KEY, '1'); return; }
    const t = setTimeout(() => setOpen(true), 1500);
    return () => clearTimeout(t);
  }, [user]);

  if (!open) return null;
  const c = COPY[language] ?? COPY['zh-Hans'];
  const enable = async () => {
    const r = await ensureBrowserPush();
    if (r.ok) { setState('done'); localStorage.setItem(NOTIFY_GUIDE_KEY, '1'); setTimeout(() => setOpen(false), 1200); }
    else setState('err');
  };
  const skip = () => { localStorage.setItem(NOTIFY_GUIDE_KEY, '1'); setOpen(false); };

  return (
    <div style={{ position: 'fixed', right: 16, bottom: 72, zIndex: 60, width: 'min(340px, calc(100vw - 32px))', background: '#10151c', border: '1px solid #1f2a3a', borderRadius: 14, padding: '16px 16px 12px', boxShadow: '0 12px 40px rgba(0,0,0,0.5)' }}>
      <div style={{ fontSize: 15, fontWeight: 700, color: '#e8eef4' }}>{c.title}</div>
      <div style={{ fontSize: 12.5, color: '#8a97a8', marginTop: 4, lineHeight: 1.55 }}>{c.desc}</div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 12 }}>
        <button onClick={enable} style={{ flex: 1, background: state === 'done' ? '#0f7a3d' : '#16a34a', color: '#fff', border: 'none', borderRadius: 8, padding: '8px 0', fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>
          {state === 'done' ? c.done : c.btn}
        </button>
        <button onClick={skip} style={{ background: 'transparent', color: '#8a97a8', border: '1px solid #2a3648', borderRadius: 8, padding: '8px 14px', fontSize: 13, cursor: 'pointer' }}>{c.skip}</button>
      </div>
      {state === 'err' && <div style={{ fontSize: 12, color: '#f59e0b', marginTop: 8 }}>{c.err}</div>}
    </div>
  );
}
